import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { EditOutlined } from "@ant-design/icons";
import AdminName from "./AdminName";
import { USER_PROFILE } from "@src/helpers/imagesConstants";
import AdminUniqueId from "./AdminUniqueId";
import AdminMobile from "./AdminMobile";
import AdminEmail from "./AdminEmail";
import AdminUserName from "./AdminUsename";
import AdminPassword from "./AdminPassword";
import ChangePasswordOnLogin from "./ChangePasswordLogin";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  getKitListRequest,
  getOperator,
  getOperatorRequest,
  getOrganizationAdmin,
  getOrganizationAdminRequest,
  upsertOperator,
  upsertOperatorClear,
  upsertOperatorRequest,
  useDynamicSelector } from
"@src/redux";
import { getUuid } from "@src/helpers/functions";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

interface OperatorAdminFormProps {
  mutationType: "edit" | "add";
  onCancel: () => void;
  item: any;
}
interface mobileObject {
  number?: string;
  country_code?: string;
  country_short_code?: string;
}

const OperatorAdminForm: React.FC<OperatorAdminFormProps> = ({
  mutationType,
  onCancel,
  item
}) => {
  const [isPasswordPresent, setIsPasswordPresent] =
  useState<boolean>(false);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const [mobile, setMobile] = useState<mobileObject>({});
  const { result: getOneOperator } = useSelector(getOperator);
  const { result: updateOperationResult, loading: updateOperationLoading } =
  useSelector(upsertOperator);
  const { filter: kitFilter } = useDynamicSelector("kit_filter");

  const onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const password = event.target.value;
    setIsPasswordPresent(!!password);
    if (!password) {
      form.setFieldsValue({ changePasswordOnLogin: false });
    }
  };

  const handleChangeNumber = (values: {
    number: string;
    country_code: string;
    country_short_code: string;
  }) => {
    setMobile(values);
  };

  const onFinish = (values: any) => {
    delete values.changePasswordOnLogin;
    if (getOneOperator?.systemUser?.username) {
      delete values?.systemUser?.username;
    }
    values.mobile = mobile;
    let newId = getOneOperator?.id || getUuid();
    dispatch(
      upsertOperatorRequest({
        id: getOneOperator?.id || newId,
        data: {
          ...values,
          id: newId,
          kit: {
            id: item?.id
          },
          organizationId: item?.organization?.id
        }
      })
    );
  };

  useEffect(() => {
    if (item?.id) {
      dispatch(getOperatorRequest({ id: item?.id }));
    }
  }, [item]);

  useEffect(() => {
    if (getOneOperator?.id) {
      setMobile(getOneOperator?.mobile);
      form.setFieldsValue({
        ...getOneOperator,
        systemUser: {
          username: getOneOperator.systemUser?.username?.split("~")?.[1]
        },
        mobile: `${
        getOneOperator?.mobile?.country_short_code +
        getOneOperator?.mobile.number}`

      });
    } else {
      form.resetFields();
    }
  }, [getOneOperator]);
  useEffect(() => {
    if (updateOperationResult?.status === "success") {
      toast.success(t("kit_updated_successfully"));
      dispatch(upsertOperatorClear());
      onCancel();
      dispatch(
        getKitListRequest({
          filter: {
            ...kitFilter
          }
        })
      );
    } else if (updateOperationResult?.error?.message) {
      toast.error(updateOperationResult?.error?.message);
      dispatch(upsertOperatorClear());
    }
  }, [updateOperationResult]);

  return (
    <Form layout="vertical" form={form} onFinish={onFinish} autoComplete="off">
      {mutationType === "edit" &&
      <Row gutter={16} justify="center" align="middle">
          <img
          className="edit-role-image"
          src={USER_PROFILE}
          alt="User Profile" />
        
          <EditOutlined className="edit-avatar-icon" />
        </Row>}
      

      <Row gutter={16}>
        <Col span={12}>
          <AdminName />
        </Col>
        <Col span={12}>
          <AdminUniqueId />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <AdminMobile onChange={handleChangeNumber} />
        </Col>
        <Col span={12}>
          <AdminEmail />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <AdminUserName
            mutationType={mutationType}
            username={getOneOperator?.systemUser?.username} />
          
        </Col>
        <Col span={12}>
          <AdminPassword
            onPasswordChange={onPasswordChange}
            mutationType={mutationType}
          />
        </Col>
      </Row>
      <Row gutter={16} justify="center" align="middle">
        <Col span={24}>
          <ChangePasswordOnLogin isEnabled={isPasswordPresent} />
        </Col>
      </Row>
      <div className="admin_form_buttons">
        <Button onClick={onCancel} danger>
          {t("close")}
        </Button>
        <Button
          type={"primary"}
          htmlType="submit"
          loading={updateOperationLoading}>
          
          {item?.operator?.name ? t("update") : t("set")}
        </Button>
      </div>
    </Form>);

};

export default OperatorAdminForm;